(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const headerDetails = document.querySelector(".menu-drawer-container");
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";

		headerDetails.addEventListener("toggle", function (e) {
			const colorScheme = this.querySelector("#menu-drawer").dataset.colorScheme;
			header.classList.toggle(colorScheme);
		});

		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove("overflow-hidden");
			}
		});

		document.addEventListener("scroll", () => {
			let scrollTop = window.scrollY;
			if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.add("fixed", "animate");
			} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove("fixed", "animate");
			}
		});

	};
  
    const tidioCSS = () => {
       setTimeout(() => {
        document.querySelector('#tidio-chat-iframe').addEventListener('load', function() {
              const iframeHead = iframe.contentDocument.head;
              const styleElement = document.createElement('style');
              styleElement.type = 'text/css';
              styleElement.textContent = '#button-body{width: 90px; height: 89px; border-radius: 50%;}';
              iframeHead.appendChild(styleElement);
          });
         },5000)
    }

	document.addEventListener("shopify:section:load", header);
    document.addEventListener("DOMContentLoaded", tidioCSS);
    

	header();
})();
